/**
 * Transform an object to an URLSearchParams instance.
 *
 * @param  {Object}          obj           The object to convert.
 * @param  {String}          defaultSearch A string of defaults search params.
 * @return {URLSearchParams}
 */
function objectToURLSearchParams(obj, defaultSearch = window.location.search) {
  const urlSearchParams = new URLSearchParams(defaultSearch);
  Object.entries(obj).forEach(([name, value]) => {
    if (urlSearchParams.has(name) && !value) {
      urlSearchParams.delete(name);
    } else if (value) {
      // @todo handle complex types for value: Array, Object
      urlSearchParams.set(name, value);
    }
  });
  return urlSearchParams;
}

/**
 * Update the history with a new state.
 * @param {String} options.pathname The new pathname.
 * @param {Object} options.search   The new pathname.
 * @param {Object} options.hash     The new hash.
 * @param {String} mode Wether to push or replace the new state.
 */
function updateHistory(
  { pathname = window.location.pathname, search = {}, hash = window.location.hash },
  mode = 'replace',
  data = {},
  title = ''
) {
  if (!window.history) {
    return;
  }

  if (!['replace', 'push'].includes(mode)) {
    throw new Error('The `mode` parameter only accepts `replace` or `push` as a value.');
  }

  let url = pathname;

  const mergedSearch = objectToURLSearchParams(search);
  if (mergedSearch.toString()) {
    url += `?${mergedSearch.toString()}`;
  }

  if (hash) {
    if (hash.startsWith('#')) {
      url += hash;
    } else {
      url += `#${hash}`;
    }
  }

  const method = `${mode}State`;
  window.history[method](data, title, url);
}

/**
 * Push a new state.
 *
 * @param {Object} options The new state.
 * @param {Object} data    The data for the new state.
 * @param {String} title   The title for the new state.
 */
export function push(options, data = {}, title = '') {
  updateHistory(options, 'push', data, title);
}

/**
 * Replace a new state.
 *
 * @param {Object} options The new state.
 * @param {Object} data    The data for the new state.
 * @param {String} title   The title for the new state.
 */
export function replace(options, data = {}, title = '') {
  updateHistory(options, 'replace', data, title);
}
